import { PaneArea } from '../../types/shared'
import Measure, { IMeasureAttrs } from '../canvas/measure'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IMeasureAttrs
type PartialAttrs = Partial<Attrs>

class MeasureCreator extends Measure<Attrs> {
  mouseDowns = 1
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = Math.round(startArea.x)
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.mouseDowns = 1
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns > 1) {
      this.release()
      this.replaceMyself(Measure.fromObject<Measure>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x2 = Math.round(area.x)
    this.attrs.y2 = area.y
    this.trigger('change')
  }
}

export default MeasureCreator
